import {h, Fragment} from "preact"
import { useFacets, useSort } from "@nosto/preact"
import { sortOptions } from "../config"
import Facet from "./Facet"
import RangeFacet from "./RangeFacet"
import SelectedFilters from "./SelectedFilters"
import Icon from "./elements/Icon"
import Select from "./elements/Select"


export const toggleButtonId = "toggle-mobile-sidebar"

function ToggleSidebarButton({ className }) {
    return (
        <label
            className={`ns-act-btn ns-close-sidebar ns-p-0 ns-d-block ns-text-align-right ns-align-items-center ns-clickable ${className}`}
            for={toggleButtonId}
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <rect width="20" height="20" rx="10" fill="white"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5858 6.10006L6.10048 14.5853L5.25195 13.7368L13.7372 5.25153L14.5858 6.10006Z" fill="black"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.09957 5.41473L14.5849 13.9L13.7363 14.7485L5.25105 6.26326L6.09957 5.41473Z" fill="black"/>
            </svg>
        </label>
    )
}

export default function SideBar() {
    const { loading, facets } = useFacets()
    const { activeSort, setSort } = useSort(sortOptions)

    const handleSortChange = event => {
        setSort(event.target.getAttribute("sortValue"))
    }
    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    return facets?.length > 0 ? (
        <>
            <input type="checkbox" id={toggleButtonId} class="ns-facet-sidebar-toggle ns-d-none" />
            <label
                class="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black ns-d-none"
                for={toggleButtonId}
            />
            <div class="ns-sidebar-wrapper nsnone ns-h-100">
                <div class="ns-sidebar-content ns-relative ns-background-white ns-h-100 ns-mr-0 ns-mr-md-auto">
                    <div class="ns-sidebar-header ns-d-flex ns-justify-content-between ns-align-items-center">
                        <span class="">Filter & Sort</span>
                        <ToggleSidebarButton />
                    </div>
                    <SelectedFilters />
                    <div class="ns-sidebar-menu">
                        <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                            <Select
                                value={activeSort}
                                onChange={e => handleSortChange(e)}
                                className="ns-selection-dropdown-sort-menu"
                                options={options}
                                label={"Sort by"}
                            /> 
                            {facets?.map(facet => {
                                switch (facet.type) {
                                    case "terms":
                                        return <Facet key={facet.id} facet={facet} />
                                    case "stats":
                                        return <RangeFacet key={facet.id} facet={facet} />
                                    default:
                                        return null
                                }
                            })}
                        </ul>
                    </div>
                    <div class="ns-sidebar-actions" onClick={(e) => e.target.closest(".ns-sidebar-wrapper")?.querySelector(".ns-close-sidebar")?.click()}>
                        <button>Done</button>
                    </div>
                </div>
            </div>
        </>
    ) : (
        ""
    )
}
